export const links = [
  {
    name: "Home",
    submenu: false,
    link: "/",
  },
  {
    name: "Top Projects",
    submenu: false,
    link: "/trending-projects",
  },
  {
    name: "Developers",
    submenu: false,
    link: "/developer",
  },
  {
    name: "Cities",
    submenu: true,
    link: "/cities",  // Clicking "Cities" navigates to this page
    sublinks: [
      { name: "Mumbai", link: "/location/mumbai" },
      { name: "Pune", link: "/location/pune" },
      { name: "Bangalore", link: "/location/bengaluru" },
      { name: "Gurugram", link: "/location/gurugram" },
    ],
  },
  {
    name: "Blogs",
    submenu: false,
    link: "/blogs",
  },
  {
    name: "Careers",
    submenu: false,
    link: "/careers",
  },
];
